import { render, staticRenderFns } from "./GuppyChatSendTextMessage.vue?vue&type=template&id=86f6c266&"
import script from "./GuppyChatSendTextMessage.vue?vue&type=script&lang=js&"
export * from "./GuppyChatSendTextMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports